import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'
import {FormattedMessage} from 'react-intl';
import styles from './styles.module.scss';

const Button = ({
                  variant = 'primary',
                  label,
                  onClick,
                  Component = Button,
                  type,
                  className,
                  ...rest
                }) => {
  return (
    <button
      className={classnames(styles.button, styles[variant], className)}
      onClick={onClick}
      type={type}
      {...rest}
    >
      {label}
    </button>
  )
};

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
  label: PropTypes.node,
  onClick: PropTypes.func,
  Component: PropTypes.element,
  type: PropTypes.string,
};

export default Button;
